import { Component, Inject, Input, NgZone, OnDestroy, PLATFORM_ID } from '@angular/core';
import * as am5 from '@amcharts/amcharts5';
import themesAnimated from '@amcharts/amcharts5/themes/Animated';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'skudo-base-chart',
    templateUrl: './skudo-base-chart.component.html',
    standalone: false
})
export class SkudoBaseChartComponent implements OnDestroy {
  @Input() identifier = `skudo-line-chart-div`;
  @Input() loading = false;

  protected root!: am5.Root;
  protected isInitialized = false;
  protected defaultColorsByIndex = [0x14213d, 0xc73232, 0xf3a229, 0x6f747c, 0x9198a7, 0xe5e5e5];

  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(@Inject(PLATFORM_ID) protected platformId: Object, protected zone: NgZone) {}

  protected browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }

  protected initChart(): void {
    this.root = am5.Root.new(this.identifier);
    this.root.setThemes([themesAnimated.new(this.root)]);
    // Remove Chart Logo
    this.root._logo?.dispose();
    this.isInitialized = true;
  }

  protected whenChartIsInitialized(fn: () => void) {
    if (this.isInitialized) {
      fn.call(this);
    } else {
      setTimeout(() => this.whenChartIsInitialized(fn), 100);
    }
  }

  ngOnDestroy() {
    this.browserOnly(() => {
      if (this.root) {
        this.root.dispose();
      }
      this.isInitialized = false;
    });
  }
}
